export default "__VITE_ASSET__C8MBF7dn__"